// @ts-ignore
import {formatInTimeZone} from 'date-fns-tz'

export const useMoneyFormat = () => {
    const formatMoney = (value: number): string => {
        return value.toFixed(0).replace('.', ',')
    }
    return {
        formatMoney,
    }
}


